import { emperor } from '~/services';

//comment|text, image|file, buildings[]
export const createPostGroupComment = async (
  templateData: FormData
): Promise<any> => {
  return await emperor.post('groupcomment/multi-post', templateData);
};

export const fetchCobuPlusBuildings = async (): Promise<any> => {
  return await emperor.get('/building/cobuplus-buildings');
};

export const fetchHomebodyBuildings = async (): Promise<any> => {
  return await emperor.get('/building/homebody-buildings');
};

export const getAllPinnedPosts = async () => {
  return await emperor.get('groupcomment/all-pinned');
};

export const bulkUnpinPosts = async (uuids: string[], hidden = false) => {
  return await emperor.post('groupcomment/bulk-unpin', { uuids, hidden });
};
